import webApi from "../../WebApi/WebApi";

export const getAddSegment = async () => {
  return await webApi.post(`/customer/segment/list-segment`, {});
};

export const getAddSegmentToAll = async (Segment) => {
  console.log("type");
  return await webApi.post(`/customer/segment/list-segment`, {
    segmentCode: Number(Segment),
  });
};

export const getSegmentAdd = async (data, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/segment/add-segment`, data);
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};
export const addProduct = async (data, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(
      `/customer/supplier/add-product-supplier`,
      data
    );
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

//Segment all list

export const getSegmentList = async (data) => {
  return await webApi.get(`/customer/segment/list-user-segment`, {});
};

//delete segment

export const deleteSegment = async (SegmentId, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/segment/delete-segment`, {
      segmentCode: SegmentId,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getSegmentUnspcAdd = async (segmentCode, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/unspsc/list-unspsc`, {
      segmentCode: segmentCode,
      count: 1000,
    });
    // console.log("ress3333-->", res);
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getFamilyUnspcAdd = async (
  segmentCode,
  familyCode,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/unspsc/list-unspsc`, {
      segmentCode: segmentCode,
      familyCode: familyCode,
      count: 1000,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getClassUnspcAdd = async (
  segmentCode,
  familyCode,
  classCode,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/unspsc/list-unspsc`, {
      segmentCode: segmentCode,
      familyCode: familyCode,
      classCode: classCode,
      count: 1000,
    });
    if (res.status === 200) {
      const r = await res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const searchUnspc = async (searchKeyword, page, role, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/segment/list-segment-search`, {
      searchKeyword,
      page,
      role
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something went wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getSelectedUnspscDetails = async (result, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/segment/get-unspsc-details`, {
      result
    });
    if (res.status === 200) {
      return onSuccess(res.data);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const searchUnspcGlobal = async (
  searchKeyword,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(
      `/customer/segment/list-segment-global-search`,
      {
        searchKeyword,
      }
    );
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};
